var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4772_11647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666715 0.0297852H15.3333C15.7015 0.0297852 16 0.328262 16 0.696452V2.22513C16 2.39332 15.9368 2.55486 15.8225 2.67829C14.1476 4.48778 11.6163 7.28009 10.694 8.29899H7.78938C7.59728 8.29899 7.44156 8.45471 7.44156 8.64681C7.44156 8.83891 7.59728 8.99463 7.78938 8.99463H10.342V15.6267C10.342 15.8613 10.1061 16.0225 9.88748 15.9372L6.11402 14.4644C5.85818 14.3645 5.68976 14.118 5.68976 13.8433V8.94757C5.68976 8.78067 5.62716 8.61984 5.51432 8.49686L0.175438 2.67801C0.0625979 2.55502 -5.23493e-06 2.39418 3.28631e-10 2.22728L4.80205e-05 0.69643C5.95697e-05 0.328249 0.298533 0.0297852 0.666715 0.0297852Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4772_11647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7cbf6374e7971ede24d9e1ddc46b7b23.svg";
export { ForwardRef as ReactComponent };